import React from 'react'
import { TopDiv } from './TopStyles'

function Top() {
    return (
      <TopDiv/>
    )
}

export default Top
